import React from "react";

interface ScienceProps extends React.SVGProps<SVGSVGElement> {
  fill?: string;
  stroke?: string;
  width?: number | string;
  height?: number | string;
}

const Science: React.FC<ScienceProps> = ({
  fill = "#3C3C3C",
  stroke = "none",
  width = 24,
  height = 24,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.0732422 19V17H5.07324V15C3.68991 15 2.51074 14.5125 1.53574 13.5375C0.560742 12.5625 0.0732422 11.3833 0.0732422 10C0.0732422 8.98333 0.352409 8.05833 0.910742 7.225C1.46908 6.39167 2.22324 5.78333 3.17324 5.4C3.30658 4.83333 3.60241 4.375 4.06074 4.025C4.51908 3.675 5.03991 3.5 5.62324 3.5L5.07324 1.95L6.02324 1.6L5.67324 0.7L7.57324 0L7.87324 0.95L8.82324 0.6L11.5732 8.1L10.6232 8.45L10.9732 9.4L9.07324 10.1L8.77324 9.15L7.82324 9.5L7.22324 7.85C6.97324 8.08333 6.68574 8.25833 6.36074 8.375C6.03574 8.49167 5.70658 8.53333 5.37324 8.5C5.00658 8.46667 4.66491 8.35417 4.34824 8.1625C4.03158 7.97083 3.75658 7.73333 3.52324 7.45C3.07324 7.71667 2.71908 8.075 2.46074 8.525C2.20241 8.975 2.07324 9.46667 2.07324 10C2.07324 10.8333 2.36491 11.5417 2.94824 12.125C3.53158 12.7083 4.23991 13 5.07324 13H13.0732V15H8.07324V17H14.0732V19H0.0732422ZM8.72324 7.55L9.62324 7.2L7.92324 2.5L6.97324 2.85L8.72324 7.55ZM5.57324 7C5.85658 7 6.09408 6.90417 6.28574 6.7125C6.47741 6.52083 6.57324 6.28333 6.57324 6C6.57324 5.71667 6.47741 5.47917 6.28574 5.2875C6.09408 5.09583 5.85658 5 5.57324 5C5.28991 5 5.05241 5.09583 4.86074 5.2875C4.66908 5.47917 4.57324 5.71667 4.57324 6C4.57324 6.28333 4.66908 6.52083 4.86074 6.7125C5.05241 6.90417 5.28991 7 5.57324 7Z"
        fill={fill}
        stroke={stroke}
      />
    </svg>
  );
};

export default Science;
